import { Map } from 'immutable';
import { DOCUMENTS_CHANGED, WS_DATA_DOCUMENTS } from '../constants/document.constants';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';

// `data` holds the API's Document[] as-is (plain objects): it is only ever replaced wholesale and is
// handed straight to the DataGrid, so wrapping each entry in a Record would buy nothing.
// (Map rather than fromJS so the empty array isn't converted to a List.)
export const initialState = Map({
	fetched: false,
	data: [],
});

function reducer(state: Map = initialState, action) {
	switch(action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case DOCUMENTS_CHANGED:
		case WS_DATA_DOCUMENTS: {
			const documents = action.type === DOCUMENTS_CHANGED ? action.documents : action.data;
			return state
				.set('data', Array.isArray(documents) ? documents : [])
				.set('fetched', true);
		}
		default:
			return state;
	}
}

export default reducer;
